import { render, staticRenderFns } from "./ProductionTaskList.vue?vue&type=template&id=7c0bf286&"
import script from "./ProductionTaskList.vue?vue&type=script&lang=js&"
export * from "./ProductionTaskList.vue?vue&type=script&lang=js&"
import style0 from "./ProductionTaskList.vue?vue&type=style&index=0&id=7c0bf286&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports